const {
  API_ADDRESS,
  PUBLIC_API_ADDRESS,
  CDN_ADDRESS,
  RUN_ADDRESS,
  PUBLIC_RUN_ADDRESS,
  AUTHOR_ADDRESS,
  STYLES_REVIEW_ADDRESS,
  DEPLOYMENT_ENV,
  HOST_ADDRESS,
  NODE_ENV,
  PORT,
  CLOUD_CONVERT_API_KEY,
  LIVEBLOCKS_PUBLIC_API_KEY,
  GITLAB_UNLEASH_CONNECT_SRC,
  MIXPANEL_TOKEN,
  GLEAP_SDK_KEY,
  DATADOG_TOKEN,
  VERSION,
  STRIPE_DASHBOARD_URL,
  STRIPE_PAYWALL_URL,
  STRIPE_API_PAYWALL_URL,
  RECAPTCHA_SCORE_KEY,
  RECAPTCHA_CHALLANGE_KEY,
  RECAPTCHA_API_KEY,
  RECAPTCHA_PROJECT_ID,
  CUSTOMIZER_ADDRESS,
} = process.env as Record<string, string>;

export {
  API_ADDRESS,
  PUBLIC_API_ADDRESS,
  CDN_ADDRESS,
  RUN_ADDRESS,
  PUBLIC_RUN_ADDRESS,
  AUTHOR_ADDRESS,
  STYLES_REVIEW_ADDRESS,
  DEPLOYMENT_ENV,
  HOST_ADDRESS,
  NODE_ENV,
  PORT,
  CLOUD_CONVERT_API_KEY,
  LIVEBLOCKS_PUBLIC_API_KEY,
  GITLAB_UNLEASH_CONNECT_SRC,
  MIXPANEL_TOKEN,
  GLEAP_SDK_KEY,
  DATADOG_TOKEN,
  VERSION,
  STRIPE_DASHBOARD_URL,
  STRIPE_PAYWALL_URL,
  STRIPE_API_PAYWALL_URL,
  RECAPTCHA_SCORE_KEY,
  RECAPTCHA_CHALLANGE_KEY,
  RECAPTCHA_API_KEY,
  RECAPTCHA_PROJECT_ID,
  CUSTOMIZER_ADDRESS,
};
